/* ============================================================================
 * Salon Cosmetics — Notify me when back in stock (Klaviyo BIS, variant-niveau)
 * v5 — alle fixes:
 *  - script beheert zichtbaarheid notify-knop zelf (soldout-container niet nodig)
 *  - variant-detectie via URL + kleurpicker-radio's (yn-laag)
 *  - inline e-mailveld vervangt de knop bij klik (radius 99, site-paars #A79FE7,
 *    font gekopieerd van de knop; inputveld kleiner en zonder uppercase)
 *  - geen login-redirect meer (nieuwe Shopify customer accounts breken die flow)
 *  - succestekst blijft zichtbaar na inschrijving (zit ín de .notify container)
 *  - dubbele inschrijving geblokkeerd
 *  - .buy-zichtbaarheid elke 500ms afgedwongen → sticky ATC doet ook mee
 *  - auto-select eerste leverbare kleur bij load (Denise-fix)
 *  - e-mail wordt onthouden: volgende inschrijving is 1 klik
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__scNotifyInit) return;
  window.__scNotifyInit = true;

  var CFG = Object.assign(
    {
      klaviyoKey: 'TavBbm',
      revision: '2024-06-15',
      eventName: 'Back In Stock Requested',
      customer: null,
      // Springt bij paginaload naar de eerste leverbare kleur wanneer de
      // default-selectie uitverkocht is (de "Denise-fix" van AndBloom).
      autoSelectAvailable: true,
      // AndBloom-stijl gridfilter: verberg product-cards die volledig
      // uitverkocht zijn. Voor SC default uit (assortiment wordt herbevoorraad).
      hideSoldOutCards: false,
      cardSelector: '.sc-product-card',
      storageKey: 'sc_bis_v1',
      accentColor: '#a79fe7',
      radius: '99px',
      formPlaceholder: 'jouw@emailadres.nl',
      formButtonText: 'Bevestig',
      formErrorText: 'Vul een geldig e-mailadres in'
    },
    window.__scNotifyConfig || {}
  );

  var NOTIFY_SEL = '.notify';
  var DEFAULT_TEXT_SEL = '.notify-default-text';
  var SUCCESS_SEL = '.notify-success, .notify-succes';
  var EMAIL_SEL = 'input.notify-email, .notify-email input';
  var FORM_ID = 'sc-notify-form';
  var PICKER_RADIO_SEL =
    'fieldset.instant-variant-picker input[type="radio"], [data-instant-type="VARIANT_PICKER"] input[type="radio"]';

  var formOpen = false;

  /* ---------------------------------------------------------------- utils */

  function root() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return r.endsWith('/') ? r : r + '/';
  }

  function productHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function normalizeImageUrl(u) {
    if (!u) return '';
    var s = String(u);
    if (s.indexOf('//') === 0) return 'https:' + s;
    if (s.indexOf('/') === 0) return location.origin + s;
    return s;
  }

  function formatMoney(cents) {
    var n = Number(cents || 0) / 100;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: cur }).format(n);
    } catch (e) {
      return '€' + n.toFixed(2);
    }
  }

  function validEmail(s) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(s || '').trim());
  }

  function readStore() {
    try { return JSON.parse(localStorage.getItem(CFG.storageKey) || '{}'); } catch (e) { return {}; }
  }
  function markSubscribed(variantId) {
    try {
      var s = readStore();
      s[String(variantId)] = Date.now();
      localStorage.setItem(CFG.storageKey, JSON.stringify(s));
    } catch (e) {}
  }
  function isSubscribed(variantId) {
    var s = readStore();
    var t = s[String(variantId)];
    return !!t && Date.now() - t < 90 * 24 * 3600 * 1000; // 90 dagen
  }

  // Laatst gebruikte e-mail onthouden zodat een 2e kleur 1 klik is
  function rememberEmail(email) {
    try { localStorage.setItem(CFG.storageKey + '_email', email); } catch (e) {}
  }
  function knownEmail() {
    if (CFG.customer && CFG.customer.email) return CFG.customer.email;
    try {
      var e = localStorage.getItem(CFG.storageKey + '_email');
      if (e && validEmail(e)) return e;
    } catch (e) {}
    return null;
  }

  /* -------------------------------------------------------- product state */

  var product = null;

  function loadProduct() {
    var handle = productHandle();
    if (!handle) return Promise.resolve(null);
    return fetch(root() + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { product = p; return p; })
      .catch(function () { return null; });
  }

  function urlVariantId() {
    try { return new URL(location.href).searchParams.get('variant'); } catch (e) { return null; }
  }

  function variantById(id) {
    if (!product || !id) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(id)) return product.variants[i];
    }
    return null;
  }

  function firstAvailableVariant() {
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i] && product.variants[i].available) return product.variants[i];
    }
    return product.variants[0] || null;
  }

  // De aangevinkte kleur-radio in de picker → variant (alleen single-option;
  // kleurgroep-radio's matchen geen optiewaarde en vallen er vanzelf uit)
  function checkedPickerVariant() {
    if (!product || (product.options || []).length > 1) return null;
    var radios = document.querySelectorAll(PICKER_RADIO_SEL);
    for (var i = 0; i < radios.length; i++) {
      if (!radios[i].checked) continue;
      var val = String(radios[i].value || '').trim().toLowerCase();
      if (!val) continue;
      for (var j = 0; j < product.variants.length; j++) {
        var v = product.variants[j];
        if (
          val === String(v.option1 || '').trim().toLowerCase() ||
          val === String(v.title || '').trim().toLowerCase()
        ) return v;
      }
    }
    return null;
  }

  // Wat de klant nú ziet: URL-param (yn synct die) → aangevinkte radio → null
  function displayedVariant() {
    var v = variantById(urlVariantId());
    if (v) return v;
    return checkedPickerVariant();
  }

  // Doelvariant voor inschrijven: getoond → anders eerste leverbare
  function currentVariant(overrideId) {
    if (!product || !product.variants || !product.variants.length) return null;
    return variantById(overrideId) || displayedVariant() || firstAvailableVariant();
  }

  // Is de getoonde selectie uitverkocht?
  function shownSoldOut() {
    if (!product) return false;
    var shown = displayedVariant();
    if (shown) return shown.available === false;
    var bodyAttr = document.body.getAttribute('data-yn-variant-available');
    if (bodyAttr) return bodyAttr === 'false';
    return product.available === false; // niets expliciets: hele product
  }

  function colorOf(variant) {
    if (!product || !variant) return '';
    var names = (product.options || []).map(function (o) {
      return String((o && o.name) || o || '').toLowerCase();
    });
    var idx = names.findIndex(function (n) {
      return n === 'kleur' || n === 'color' || n === 'colour';
    });
    if (idx >= 0) return variant['option' + (idx + 1)] || '';
    if (variant.option1 && String(variant.option1).toLowerCase() !== 'default title') return variant.option1;
    return '';
  }

  /* -------------------------------------------------- zichtbaarheid + tekst */

  // Verbergen = inline display:none !important; tonen = inline weghalen →
  // natuurlijke CSS (zelfde patroon als het yn-script)
  function setHidden(selector, hide) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (hide) el.style.setProperty('display', 'none', 'important');
      else el.style.removeProperty('display');
    });
  }

  function setFormHidden(hide) {
    var f = document.getElementById(FORM_ID);
    if (!f) return;
    if (hide) f.style.setProperty('display', 'none', 'important');
    else f.style.removeProperty('display');
  }

  // Staat de succestekst bínnen de .notify container (SC-design)?
  function successInsideNotify() {
    return !!document.querySelector('.notify .notify-success, .notify .notify-succes');
  }

  // Zelfde .buy-logica als het yn-script, maar dan ook voor elementen die
  // later mounten (zoals de sticky ATC, die pas bij scrollen verschijnt)
  function enforceBuyVisibility(soldOut) {
    document.querySelectorAll('.buy, .yn-buy').forEach(function (el) {
      if (el.closest('.color-groups')) return;
      if (soldOut) el.style.setProperty('display', 'none', 'important');
      else el.style.removeProperty('display');
    });
  }

  function refreshNotifyState() {
    if (!product) return;
    var soldOut = shownSoldOut();
    enforceBuyVisibility(soldOut);
    if (!soldOut) {
      formOpen = false;
      setHidden(NOTIFY_SEL, true);
      setHidden(SUCCESS_SEL, true);
      setFormHidden(true);
      return;
    }
    var v = currentVariant();
    var done = v && isSubscribed(v.id);
    if (done) formOpen = false;
    var succInside = successInsideNotify();
    // Veldje open = knop weg; na inschrijving blijft de knop-container staan
    // met de succestekst erin (tenzij de succestekst buiten .notify staat)
    setHidden(NOTIFY_SEL, formOpen || (done && !succInside));
    setHidden(DEFAULT_TEXT_SEL, done);
    setHidden(SUCCESS_SEL, !done);
    setFormHidden(!formOpen || done);
    document.querySelectorAll(NOTIFY_SEL).forEach(function (el) {
      el.style.cursor = done ? 'default' : 'pointer';
    });
  }

  /* ------------------------------------------------------ Klaviyo helpers */

  function subscribeBIS(email, variantId) {
    if (!email || !variantId) return Promise.resolve(false);
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
          }
        }
      }
    };
    return fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
        encodeURIComponent(CFG.klaviyoKey),
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: CFG.revision },
        body: JSON.stringify(payload)
      }
    )
      .then(function (r) { return r.ok; })
      .catch(function (e) {
        console.warn('[sc-notify] BIS subscribe failed', e);
        return false;
      });
  }

  function identify(email) {
    var c = CFG.customer || {};
    var props = { email: email };
    if (c.firstName) props.first_name = c.firstName;
    if (c.lastName) props.last_name = c.lastName;
    if (c.id) props.ShopifyCustomerID = c.id;
    if (window.klaviyo && typeof klaviyo.identify === 'function') { klaviyo.identify(props); return; }
    window._learnq = window._learnq || [];
    if (typeof window._learnq.identify === 'function') { window._learnq.identify(props); return; }
    if (Array.isArray(window._learnq)) window._learnq.push(['identify', props]);
  }

  function track(name, props) {
    if (window.klaviyo && typeof klaviyo.track === 'function') { klaviyo.track(name, props); return; }
    window._learnq = window._learnq || [];
    if (typeof window._learnq.track === 'function') { window._learnq.track(name, props); return; }
    if (Array.isArray(window._learnq)) window._learnq.push(['track', name, props]);
  }

  function buildPayload(variant) {
    if (!product || !variant) return null;
    var url = root() + 'products/' + product.handle;
    var img = '';
    if (product.featured_image) img = product.featured_image;
    else if (product.images && product.images[0]) img = product.images[0];
    return {
      ProductID: product.id || '',
      VariantID: variant.id || '',
      Title: product.title || '',
      VariantTitle: variant.title || '',
      Color: colorOf(variant),
      URL: url,
      VariantURL: url + '?variant=' + variant.id,
      ImageURL: normalizeImageUrl((variant.featured_image && variant.featured_image.src) || img),
      Handle: product.handle || '',
      Price: variant.price != null ? formatMoney(variant.price) : '',
      PriceCents: variant.price != null ? Number(variant.price) : ''
    };
  }

  /* --------------------------------------------------------- notify flow */

  function performSubscribe(email, variant) {
    return subscribeBIS(email, variant.id).then(function (ok) {
      if (!ok) return false;
      identify(email);
      var payload = buildPayload(variant);
      if (payload) track(CFG.eventName, Object.assign({}, payload, { Email: email }));
      rememberEmail(email);
      markSubscribed(variant.id);
      formOpen = false;
      refreshNotifyState();
      return true;
    });
  }

  // Buitenste .notify (Instant nest soms twee containers met dezelfde class)
  function outermostNotify(el) {
    var cur = el;
    while (cur.parentElement) {
      var up = cur.parentElement.closest(NOTIFY_SEL);
      if (!up) break;
      cur = up;
    }
    return cur;
  }

  // Stijl van de bestaande knop overnemen (font + tekstkleur), zodat het
  // veldje meebeweegt met het Instant-design
  function sampleButtonStyle(notifyEl) {
    var out = { font: 'inherit', color: '#fff', size: '', weight: '', transform: '', spacing: '' };
    var textEl = notifyEl.querySelector('p, span, h1, h2, h3, h4, h5, h6') || notifyEl;
    var cs = getComputedStyle(textEl);
    out.font = cs.fontFamily || 'inherit';
    out.color = cs.color || '#fff';
    out.size = cs.fontSize || '';
    out.weight = cs.fontWeight || '';
    out.transform = cs.textTransform || '';
    out.spacing = cs.letterSpacing || '';
    return out;
  }

  // Inline e-mailveld dat de notify-knop op z'n eigen plek vervangt
  function showInlineForm(clickedEl) {
    var outer = outermostNotify(clickedEl);
    var form = document.getElementById(FORM_ID);

    if (!form) {
      var st = sampleButtonStyle(outer);
      var btnFontCss =
        'font-family:' + st.font + ';' +
        (st.size ? 'font-size:' + st.size + ';' : '') +
        (st.weight ? 'font-weight:' + st.weight + ';' : '') +
        (st.transform ? 'text-transform:' + st.transform + ';' : '') +
        (st.spacing && st.spacing !== 'normal' ? 'letter-spacing:' + st.spacing + ';' : '');
      // Inputveld: zelfde familie maar kleiner en zonder uppercase/spacing
      var inputFontCss =
        'font-family:' + st.font + ';font-size:14px;text-transform:none;letter-spacing:normal;';

      form = document.createElement('div');
      form.id = FORM_ID;
      form.style.cssText =
        'display:flex;flex-wrap:wrap;gap:12px;width:100%;flex:1 1 100%;' +
        'align-items:stretch;box-sizing:border-box;';

      var input = document.createElement('input');
      input.type = 'email';
      input.autocomplete = 'email';
      input.placeholder = CFG.formPlaceholder;
      input.style.cssText =
        'flex:1 1 160px;min-width:0;box-sizing:border-box;padding:13px 22px;' +
        'border:1px solid ' + CFG.accentColor + ';border-radius:' + CFG.radius + ';' +
        'background:#fff;color:#222;outline:none;' + inputFontCss;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = CFG.formButtonText;
      btn.style.cssText =
        'flex:0 0 auto;box-sizing:border-box;padding:13px 28px;border:none;' +
        'border-radius:' + CFG.radius + ';background:' + CFG.accentColor + ';' +
        'color:' + st.color + ';cursor:pointer;white-space:nowrap;' + btnFontCss;

      var err = document.createElement('div');
      err.textContent = CFG.formErrorText;
      err.style.cssText =
        'display:none;flex-basis:100%;color:#c0392b;font-family:' + st.font + ';font-size:0.85em;padding-left:20px;';

      function submit() {
        var val = String(input.value || '').trim();
        if (!validEmail(val)) {
          err.style.display = 'block';
          input.focus();
          return;
        }
        err.style.display = 'none';
        btn.disabled = true;
        btn.style.opacity = '0.7';
        var v = currentVariant();
        if (!v) { btn.disabled = false; btn.style.opacity = ''; return; }
        performSubscribe(val, v).then(function (ok) {
          btn.disabled = false;
          btn.style.opacity = '';
          if (!ok) err.style.display = 'block';
        });
      }

      btn.addEventListener('click', submit);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit(); }
      });

      form.appendChild(input);
      form.appendChild(btn);
      form.appendChild(err);
      outer.insertAdjacentElement('afterend', form);
    }

    formOpen = true;
    refreshNotifyState(); // knop weg, veldje op z'n plek
    var inp = form.querySelector('input');
    if (inp) inp.focus();
  }

  function onNotifyClick(e) {
    if (e.target.closest('#' + FORM_ID)) return; // klikken ín het veldje: negeren
    var btn = e.target.closest(NOTIFY_SEL);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var v = currentVariant();
    if (!v) return;
    if (isSubscribed(v.id)) return; // al ingeschreven voor deze kleur

    // 1) Bekende klant of eerder gebruikt adres: direct inschrijven
    var email = knownEmail();
    if (email) {
      if (btn.__scBusy) return;
      btn.__scBusy = true;
      performSubscribe(email, v).finally(function () { btn.__scBusy = false; });
      return;
    }

    // 2) Zelf gedesignd e-mailveld (.notify-email) met geldige invoer
    var designed = document.querySelector(EMAIL_SEL);
    if (designed) {
      var val = String(designed.value || '').trim();
      if (validEmail(val)) {
        performSubscribe(val, v);
      } else {
        designed.focus();
        designed.style.outline = '2px solid #c0392b';
        setTimeout(function () { designed.style.removeProperty('outline'); }, 1500);
      }
      return;
    }

    // 3) Anders: knop vervangen door inline veldje
    showInlineForm(btn);
  }

  /* ------------------------------------- auto-select eerste leverbare kleur */

  function autoSelectAvailable() {
    if (!CFG.autoSelectAvailable || !product) return;
    if (urlVariantId()) return; // deep-link (bv. uit Klaviyo-mail): respecteren
    if ((product.options || []).length > 1) return; // alleen single-option
    if (product.variants.length < 2) return;
    if (!shownSoldOut()) return;

    var target = firstAvailableVariant();
    if (!target || !target.available) return; // alles uitverkocht: notify is correct

    var want = String(target.option1 || target.title).trim().toLowerCase();
    var radios = document.querySelectorAll(PICKER_RADIO_SEL);
    for (var i = 0; i < radios.length; i++) {
      if (String(radios[i].value || '').trim().toLowerCase() === want) {
        radios[i].click(); // yn-script regelt URL, gallery en buy/soldout zelf
        return;
      }
    }
  }

  /* ----------------------------------- optioneel: sold-out cards verbergen */

  function initCardFilter() {
    if (!CFG.hideSoldOutCards) return;
    var cache = {};
    function evaluate(card) {
      var link = card.querySelector('a[href*="/products/"]');
      var m = link && link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      var handle = m[1];
      cache[handle] = cache[handle] ||
        fetch(root() + 'products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      cache[handle].then(function (p) {
        if (!p) return;
        var anyAvail = (p.variants || []).some(function (v) { return v && v.available; });
        if (!anyAvail) card.style.setProperty('display', 'none', 'important');
      });
    }
    var t;
    var run = function () {
      clearTimeout(t);
      t = setTimeout(function () {
        document.querySelectorAll(CFG.cardSelector).forEach(evaluate);
      }, 150);
    };
    run();
    new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------ init */

  function watchVariantChanges() {
    // Elke tick opnieuw toepassen (goedkoop en idempotent), zodat ook
    // laat-mountende elementen zoals de sticky ATC gevangen worden
    setInterval(refreshNotifyState, 500);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches(PICKER_RADIO_SEL)) {
        setTimeout(refreshNotifyState, 50);
      }
    }, true);

    ['pushState', 'replaceState'].forEach(function (m) {
      var orig = history[m];
      if (typeof orig === 'function' && !orig.__scWrapped) {
        var wrapped = function () {
          var r = orig.apply(this, arguments);
          try { refreshNotifyState(); } catch (e) {}
          return r;
        };
        wrapped.__scWrapped = true;
        history[m] = wrapped;
      }
    });
    window.addEventListener('popstate', refreshNotifyState);
  }

  function init() {
    initCardFilter();
    if (!productHandle()) return;

    // Meteen verbergen tot we weten of de getoonde variant uitverkocht is
    setHidden(NOTIFY_SEL, true);
    setHidden(SUCCESS_SEL, true);

    loadProduct().then(function (p) {
      if (!p) return;
      refreshNotifyState();
      watchVariantChanges();
      // Instant + yn-script eerst laten initialiseren, dan pas ingrijpen
      setTimeout(function () { autoSelectAvailable(); refreshNotifyState(); }, 1200);
      setTimeout(function () { autoSelectAvailable(); refreshNotifyState(); }, 2500);
    });

    document.addEventListener('click', onNotifyClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.__scNotifyRefresh = refreshNotifyState;
})();